"use strict";

module.exports = {
  'name': 'simplify',
  'category': 'Algebra',
  'syntax': ['simplify(expr)', 'simplify(expr, rules)'],
  'description': 'Simplify an expression tree.',
  'examples': ['simplify("3 + 2 / 4")', 'simplify("2x + x")', 'f = parse("x * (x + 2 + x)")', 'simplified = simplify(f)', 'simplified.eval({x: 2})'],
  'seealso': ['derivative', 'parse', 'eval']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/algebra/simplify.js
// module id = 821
// module chunks = 0